// DYNAMIC YEAR
const dynamicYearElements = document.querySelectorAll('.dynamic-year');
const currentYear = new Date().getFullYear();
dynamicYearElements.forEach(element => {
  element.textContent = currentYear;
});